import { Controller } from '@hotwired/stimulus'
import confetti from 'canvas-confetti'

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 3000 },
    colors: {
      type: Array,
      default: ['#2d6a4f', '#40916c', '#52b788', '#74c69d'],
    },
  }

  connect() {
    this.#fire()
  }

  disconnect() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId)
      this.animationId = null
    }
  }

  #fire() {
    const end = Date.now() + this.durationValue

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: this.colorsValue,
      })
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: this.colorsValue,
      })

      if (Date.now() < end) {
        this.animationId = requestAnimationFrame(frame)
      }
    }

    frame()
  }
}
